import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth } from '../firebaseConfig/firebase';
import { Container, Nav, Navbar, NavDropdown } from 'react-bootstrap'; // Importamos NavDropdown
import logo from './images/logoBlanc.png';

const Head = () => {
    const navigate = useNavigate();
    const [userEmail, setUserEmail] = useState("");
    const [fullEmail, setFullEmail] = useState("");

    const ADMIN_EMAILS = [
        "oleguer.palet@escac.es",
        "dalal.battikh@escac.es",
        "tere.zuluaga@escac.es",
        "sergio.jumilla@escac.es"
    ];

    const handleLogout = () => {
        signOut(auth).then(() => {
            navigate("/Login");
            console.log("Signed out successfully");
        }).catch((error) => console.error(error));
    }

    // Handlers de navegación
    const handleUpload = () => navigate("/Upload");
    const handleUpdateExp = () => navigate("/Updateexp");
    const handleUpdatePort = () => navigate("/Updateport");
    const handleDashboard = () => navigate("/dashboard");
    const handleHome = () => navigate("/");
    const handleResultats = () => navigate("/resultats");
    const handleControl = () => navigate("/control");
    const handleUpdateEvaluations = () => navigate("/updateevaluations");
    const handleAddTribunal = () => navigate("/addtribunal");
    const handleAll = () => navigate("/all");

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                setFullEmail(user.email);
                const userName = user.email.split('@')[0];
                setUserEmail(userName);
            } else {
                setUserEmail("");
                setFullEmail("");
            }
        });
        return () => unsubscribe();
    }, []);

    const isAdmin = ADMIN_EMAILS.includes(fullEmail);

    return (
        <Navbar variant="dark" bg="dark" expand="lg">
            <Container fluid>
                <Navbar.Brand href="#home" onClick={handleHome} style={{ cursor: 'pointer' }}>
                    <img
                        src={logo}
                        alt="Logo ESCAC"
                        style={{ width: '180px', height: 'auto' }}
                    />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="navbar-dark-example" />
                <Navbar.Collapse id="navbar-dark-example">
                    <Nav className="w-100 align-items-center">
                        {isAdmin && (
                            <>
                                {/* Resto de botones que no van en Imports */}
                                <button className="btn btn-outline-light btn-sm m-2" onClick={handleDashboard}>Dashboard</button>
                                <button className="btn btn-outline-light btn-sm m-2" onClick={handleResultats}>Resultats</button>
                                <button className="btn btn-outline-light btn-sm m-2" onClick={handleControl}>Control</button>
                                <button className="btn btn-outline-light btn-sm m-2" onClick={handleAll}>Todos</button>
                                <button className="btn btn-outline-light btn-sm m-2" onClick={handleAddTribunal}>Afegir tribunal</button>

                                {/* NUEVO MENÚ DESPLEGABLE IMPORTS */}
                                <NavDropdown title="Imports" id="nav-dropdown-imports" className="mx-2">
                                    <NavDropdown.Item onClick={handleUpload}>Upload</NavDropdown.Item>
                                    <NavDropdown.Item onClick={handleUpdateExp}>Update Exp</NavDropdown.Item>
                                    <NavDropdown.Item onClick={handleUpdatePort}>Update Portfoli</NavDropdown.Item>
                                    <NavDropdown.Item onClick={handleUpdateEvaluations}>Update Eva</NavDropdown.Item>
                                </NavDropdown>
                            </>
                        )}

                        <div className="ms-auto d-flex align-items-center">
                            <span className="text-light me-3" style={{ fontSize: '0.9rem' }}>
                                Bienvenido, <strong>{userEmail}</strong>
                            </span>
                            <button className="btn btn-primary bg-dark" onClick={handleLogout}>
                                Logout
                            </button>
                        </div>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default Head;